<template>
        <b-input-group :prepend="prepend" size="mb">
        <b-form-input
          v-model="mFrom"
          @change="changed"
          @input="changed"
          class="col-4 text-right"
        ></b-form-input>
        <b-form-select v-model="mFormat" :options="options" class="bg-secondary text-white col-3 text-right"></b-form-select>
        </b-input-group>
</template>

<script>
var toHexN = function (n, d) {
  var s = n.toString(16);
  while (s.length < d) { s = '0' + s; }
  return s.toUpperCase();
};

// var toHex2 = function (n) { return toHexN(n & 0xff,2); };
var toHex4 = function (n) { return toHexN(n & 0xffff, 4); };

export default {
  name: 'hexinput',
  components: {},
  data () {
    return {
      trueValue: 0,
      mFormat: 'dec',
      options: [
        { text: 'HEX', value: 'hex' },
        { text: 'DEC', value: 'dec' }
      ]
    }
  },
  props: ['value', 'prepend'],
  computed: {
    mFrom: {
      get () {
        if (this.mFormat === 'dec') {
          return this.trueValue
        } else {
          return toHex4(this.trueValue)
        }
      },
      set () {
        return;
      }
    }
  },
  watch: {
    value (val) {
      console.log('From upper world', val)
      this.trueValue = this.value
    }
  },
  methods: {
    changed (val) {
      if (this.mFormat === 'dec') {
        this.trueValue = val
      } else {
        this.trueValue = parseInt(val, 16)
      }
      this.$emit('input', this.trueValue)
    }
  },
  mounted () {
    this.trueValue = this.value
  }
}
</script>

<style>
textarea {font-family: monospace !important;}
</style>
